// Helper function to get start/end of day in ISO format
function toStartOfDay(date) {
    const d = new Date(date);
    d.setUTCHours(0, 0, 0, 0);
    return d.toISOString();
}

function toEndOfDay(date) {
    const d = new Date(date);
    d.setUTCHours(23, 59, 59, 999);
    return d.toISOString();
}
angular.module("ainapp").controller("balanceSheetController", ["$scope", "app.config", "$http", "$state", "AuthenticationService",
    "MainService","$window",
    function ($scope, config, $http, $state, AuthenticationService, MainService,$window) {

        $scope.PageName = "Balance Sheet";
        $scope.TokenInfo = AuthenticationService.getTokenInfo();
        if ($scope.TokenInfo == null) {
            $state.go("login");
        } else {
            $scope.checkUserPageAccess($scope.PageName);
        }

        $scope.Init = function () {
            $scope.AccLoad = false;
            $scope.TrailBalanace = [];

            $scope.data = [];

            // $scope.Levels = [
            //     {
            //         Id: 0,
            //         Name: "level 1",
            //     },
            //     {
            //         Id: 1,
            //         Name: "level 2",
            //     },
            //     {
            //         Id: 2,
            //         Name: "level 3",
            //     },
            //     {
            //         Id: 3,
            //         Name: "level 4",
            //     },
            //     {
            //         Id: 4,
            //         Name: "level 5",
            //     },
            //     {
            //         Id: 5,
            //         Name: "level 6",
            //     },
            //     {
            //         Id: 6,
            //         Name: "All",
            //     },
            // ];

            $scope.date1 = new Date();
            var n = $scope.date1.getFullYear();
            $scope.d2 = new Date("01/01/" + n);

            $scope.TrailObj = {
                Level: 6,
                FromDate: toStartOfDay($scope.d2),
                ToDate: toEndOfDay(new Date())
            };

            $scope.finyear = {};
            MainService.getCurrentFinancialYear().then(function (response) {
                $scope.finyear = response.data;
                $scope.TrailObj.FromDate = toStartOfDay(new Date($scope.finyear.StartDate));
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            });

            $scope.CostCenters = [];
            MainService.CostCentersInTreeList().then(function (response) {
                $scope.CostCenters = response.data;
                $scope.SelectedCosts = response.data[0];
            });
        };
        $scope.Init();

        $scope.openCostCenterFilterModal = function () {
            AppReactLib.costCenterSelect.RenderCostCenterSelectModal({
                data: $scope.CostCenters,
                title: "Select Cost Centers",
                initialCostCenterIds: $scope.SelectedCostCenters, 
                initialDateRange: {
                    start: $scope.TrailObj.FromDate,
                    end: $scope.TrailObj.ToDate
                },
                initialLevelId: $scope.TrailObj.Level,
                onApply: function (values) {
                    values=values||{};
                    console.log('Applied cost centers:', values);
                    dateRange = values.dateRange || {};

                    $scope.SelectedCostCenters = values.costCenterIds;
                    $scope.TrailObj.FromDate = dateRange.start;
                    $scope.TrailObj.ToDate = dateRange.end;
                    $scope.TrailObj.Level = values.levelId;
                },
                onClose: function () {
                    console.log('Modal closed');
                }
            });
        }

        $scope.KendoSource = new kendo.data.DataSource({
            page: 1,
            pageSize: 100,
            transport: {
                read: function (o) {
                    o.data.Level = $scope.TrailObj.Level + 1;

                    o.data.FromDate = $scope.TrailObj.FromDate;
                    o.data.ToDate = $scope.TrailObj.ToDate;

                    // o.data.FromMonth = $scope.TrailObj.FromDate.getMonth() + 1;
                    // o.data.FromDay = $scope.TrailObj.FromDate.getDate();
                    // o.data.FromYear = $scope.TrailObj.FromDate.getFullYear();

                    // o.data.ToMonth = $scope.TrailObj.ToDate.getMonth() + 1;
                    // o.data.ToDay = $scope.TrailObj.ToDate.getDate();
                    // o.data.ToYear = $scope.TrailObj.ToDate.getFullYear();

                    o.data.CostCenterIds = $scope.SelectedCostCenters;
                    MainService.GetBalanceSheetReport(o.data).then(
                        function (response) {
                            var temp = {
                                Data: response.data,
                            };
                            $scope.GlData =  response.data;
                            o.success(temp);
                            console.log(response.data);
                        },
                        function (err) {
                            o.success({
                                Data: [],
                            });
                            toastr.error("NetworkError");
                        }
                    );
                },
            },
            change: function (data) { },
            schema: {
                data: "Data",
                total: "Total",
                model: {
                    id: "Id",
                    parentId: "ParentId",
                    fields: {
                        ParentId: {
                            field: "ParentId",
                            nullable: true,
                        },
                        AccountCode: {
                            type: "string",
                            editable: false,
                        },
                        Name: {
                            type: "string",
                            editable: false,
                        },
                        BalanceAmount: {
                            type: "number",
                            editable: false,
                        },
                    },
                    expanded: true,
                },
            },
            serverPaging: false,
            serverSorting: false,
            serverFiltering: false,
        });

        $scope.KendoGridOptions = getKendoGridOptions($scope.KendoSource);

        function detailInit(e) {
            $("<div/>")
                .appendTo(e.detailCell)
                .kendoGrid(getChildKendoGridOptions(e.data.Children));
        }

        function getChildKendoGridOptions(data) {
            let options = {
                stretch: true,
                //                    selectable: true,
                //                    pageable: true,
                //height: 780,
                resizable: true,
                dataSource: {
                    data: data,
                    //                        pageSize: 20,
                    schema: {
                        //                            data: "Data",
                        //                            total: "Total",
                        model: {
                            //                                id: "Id",
                            //                                parentId: "ParentId",
                            fields: {
                                //                                    ParentId: {
                                //                                        field: "ParentId",
                                //                                        nullable: true
                                //                                    },
                                AccountCode: {
                                    type: "string",
                                    editable: false,
                                },
                                Name: {
                                    type: "string",
                                    editable: false,
                                },
                                Balance: {
                                    type: "number",
                                    editable: false,
                                },
                            },
                            //                                expanded: true
                        },
                    },
                },
                detailInit: detailInit,
                dataBound: function (e) {
                    $(this.element).find(".k-grid-header").hide();
                    //                        $(this.element).closest(".k-detail-row").find(".k-hierarchy-cell").hide();

                    var items = e.sender.items();
                    items.each(function () {
                        var row = $(this);
                        var dataItem = e.sender.dataItem(row);
                        if (!dataItem.Children || dataItem.Children.length == 0) {
                            row.find(".k-hierarchy-cell").html("");
                        }
                    });
                },
                sortable: true,
                scrollable: true,
                //                    filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "AccountCode",
                        title: "Code",
                        width: "50px"
                    },
                    {
                        field: "Name",
                        title: "Name",
                        width: "150px"
                    },
                    {
                        field: "Balance",
                        title: "Balance",
                        width: "50px"
                    },
                ],
            };
            console.log("data", data);
            return options;
        }

        function getKendoGridOptions(dataSource) {
            return {
                stretch: true,
                toolbar: ["excel", "pdf"],
                pdf: {
                    fileName: "balancesheet.pdf",
                    allPages: true,
                    paperSize: "A4",
                    margin: {
                        top: "3cm",
                        right: "1cm",
                        bottom: "1cm",
                        left: "1cm"
                    },
                    template: `<div class="page-template"><div class="pageheader">Balance Sheet.</div></div>`
                },
                selectable: true,
                height: 600,
                resizable: true,
                dataSource: dataSource,
                pageSize: 100,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                scrollable: {
                    virtual: true
                },
                //                    detailInit: detailInit,
                dataBound: function (e) {
                    //                        var items = e.sender.items();
                    //                        items.each(function () {
                    //                            var row = $(this);
                    //                            var dataItem = e.sender.dataItem(row);
                    //                            if (!dataItem.Children || dataItem.Children.length == 0) {
                    //                                row.find(".k-hierarchy-cell").html("");
                    //                            }
                    //
                    //                        })
                },
                sortable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "AccountCode",
                        title: "Code",
                        width: "50px"
                    },
                    {
                        field: "Name",
                        title: "Name",
                        width: "150px",
                        template: function (dataItem) {
                            return (
                                "<a ng-dblclick='goGlDetails(dataItem)'><span style='color:" +
                                getColor(dataItem.Level) +
                                ";font-weight: " + getFontweight(dataItem.Level) +
                                ";padding-left:" +
                                10 * dataItem.Level +
                                "px'>" +
                                kendo.htmlEncode(dataItem.Name) +
                                "</span></a>"
                            );
                        },
                    },
                    {
                        field: "BalanceAmount",
                        title: "Balance",
                        width: "50px",
                        //                        template: function (dataItem) {
                        //                            return dataItem.IsLeafNode || dataItem.IsGroupTotal ?
                        //                                "<p style='text-align : right'>" + kendo.htmlEncode(dataItem.BalanceAmount) + "</p>" :
                        //                                "";
                        //                        },
                        template: function (dataItem) {
                            return dataItem.IsLeafNode || dataItem.IsGroupTotal ?
                                "<p style='text-align : right'> {{dataItem.BalanceAmount | number}}</p>" :
                                "";
                        },
                    },
                ],
            };
        }

        function getColor(level) {
            switch (level) {
                case 0:
                    return "#12837c";
                case 1:
                    return "black";
                case 2:
                    return "blue";
                case 3:
                    return "green";
                case 4:
                    return "violet";
                case 5:
                    return "orange";
                case 6:
                    return "yellow";
            }
        }

        function getFontweight(level) {
            switch (level) {
                case 0:
                    return 800;
                case 1:
                    return 700;
                case 2:
                    return 600;
                case 3:
                    return 500;
                case 4:
                    return 400;
                case 5:
                    return 300;
                case 6:
                    return 200;
            }
        }

        $scope.GetReport = function () {
            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
        };
        $scope.Refresh = function () {
            $scope.Init();
            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
        };

         $scope.goGlDetails = function(data) {
            var FromDateString = $scope.extractDate($scope.TrailObj.FromDate);
             var ToDateString  = $scope.extractDate($scope.TrailObj.ToDate);

              var url = $state.href("generalLedgerbyAcc", 
                {
                    accId : data.Id,
                    datefrom : FromDateString,
                    dateTo: ToDateString,
                });
                $window.open(url, "_blank");
        }


     $scope.PrintLedger = function () {

            var Fromdate = $scope.extractDate($scope.TrailObj.FromDate);
            var ToDate = $scope.extractDate($scope.TrailObj.ToDate);

            var array = [];
            angular.forEach($scope.GlData, function (e) {
                var temp = {
                    AccountId: e.Id,
                    AccountName: e.Name,
                    AccountCode : e.AccountCode != null ? e.AccountCode : "",
                    Balance: e.BalanceAmount,
                    Level : e.Level,
                    DateFrom: Fromdate,
                    DateTo: ToDate,
                    Color : getColor(e.Level),
                };
                array.push(temp);
            });

            $.LoadingOverlay("show", {
                image: "images/load.gif",
            });

            MainService.PrintTempBalanceSheetPrint(array).then(
                function (response) {
                    if (response.data != null) {
                        $window.open(
                            config.basePath + "/Reports/" + response.data,
                            "_blank"
                        );
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                },
                function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }
            );
        }

    },
]);
